import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { cn } from "../lib/utils"

export function AlertRenderer({ element }: RendererProps) {
  const { resolveSymbol } = useRenderContext()
  const title = element.text ? String(resolveSymbol(element.text) ?? "") : ""
  const description = element.children?.[0]?.text
    ? String(resolveSymbol(element.children[0].text) ?? "")
    : ""

  const variant = element.variant ?? "default"

  const variantClasses: Record<string, string> = {
    default: "border-border bg-background text-foreground",
    destructive: "border-destructive/50 text-destructive [&>svg]:text-destructive",
  }

  const iconMap: Record<string, string> = {
    default: "\u24D8",       // circled i
    destructive: "\u26A0",   // warning sign
  }

  return (
    <div
      role="alert"
      className={cn(
        "relative w-full rounded-lg border p-4",
        variantClasses[variant] ?? variantClasses.default,
        element.className,
      )}
      data-testid={`alert-${element.id}`}
    >
      <div className="flex gap-3">
        <span className="mt-0.5 text-base leading-none" aria-hidden="true">
          {iconMap[variant] ?? iconMap.default}
        </span>
        <div className="flex flex-col gap-1">
          {title && (
            <h5 className="mb-1 font-medium leading-none tracking-tight">{title}</h5>
          )}
          {description && (
            <div className="text-sm [&_p]:leading-relaxed">{description}</div>
          )}
        </div>
      </div>
    </div>
  )
}
